export enum SuggestionObjectType {
    classifier = 1,
    classifierRecord = 2,
    staticPage = 3,
    mLSuggestionRecord = 4,
}
